import { render } from "./StoreInfoPage.vue?vue&type=template&id=68c11f75&scoped=true"
import script from "./StoreInfoPage.vue?vue&type=script&lang=js"
export * from "./StoreInfoPage.vue?vue&type=script&lang=js"

import "./StoreInfoPage.vue?vue&type=style&index=0&id=68c11f75&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c11f75"]])

export default __exports__